import { render, staticRenderFns } from "./AwardName.vue?vue&type=template&id=4e58fe6c&scoped=true&"
import script from "./AwardName.vue?vue&type=script&lang=js&"
export * from "./AwardName.vue?vue&type=script&lang=js&"
import style0 from "./AwardName.vue?vue&type=style&index=0&id=4e58fe6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e58fe6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e58fe6c')) {
      api.createRecord('4e58fe6c', component.options)
    } else {
      api.reload('4e58fe6c', component.options)
    }
    module.hot.accept("./AwardName.vue?vue&type=template&id=4e58fe6c&scoped=true&", function () {
      api.rerender('4e58fe6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/AwardName.vue"
export default component.exports